import React from "react";
import Button from "../../Shared/Button/Button";
import UserDetails from "../UserDetails/UserDetails";
import UserRating from "../UserRating/UserRating";
import { userData } from "../../../data/user";
import { Link } from "react-router-dom";

const Rating = () => {
  return (
    <div className="mb-[50px] w-full rounded border-2 border-black border-opacity-25 py-8">
      <div className="flex justify-between px-[60px] pb-[60px]">
        <UserDetails user={userData} />
        <UserRating user={userData} />
      </div>
      <div className="grid grid-cols-4 gap-3 px-24">
        <Link to="/userlisting/active" className="block w-full">
          <Button
            variant="secondary"
            text={"Active Listing (20)"}
            className="!w-full rounded"
          />
        </Link>

        <Link to="/userlisting/sold">
          <Button
            text={"Sold Items (158)"}
            variant="primary"
            className="!w-full rounded"
          />
        </Link>
        <Link to="/userlisting/reviewsgiven">
          <Button
            text={"Reviews Given"}
            variant="purple"
            className="!w-full rounded"
          />
        </Link>
        <Link to="/userlisting/reviewsreceieved">
          <Button
            text={"Reviews Recieved"}
            variant="blue"
            className="!w-full rounded"
          />
        </Link>
      </div>
    </div>
  );
};

export default Rating;
